import React from 'react';
import { observer } from 'mobx-react';

import { ComponentRegistry } from 'core/registry';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Form } from 'libs/forms/index';
import { Trans } from 'react-i18next';

import { ResetPasswordFormAppManager } from 'apps/signIn/resetPassword/appManager';

@observer
export class ResetPasswordModal extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new ResetPasswordFormAppManager(null, {});
  }

  render() {
    const { resetPasswordApp } = this.appManager;
    const { form } = resetPasswordApp;
    const {
      conf: { formTitle },
    } = form;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={resetPasswordApp.Submit}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}

ComponentRegistry.add('modals.ResetPasswordModal', ResetPasswordModal);
